/**
 * Store: Dickey bundle
 * -----------------------------------------------------------------------------
 * Handles Dickey bundle actions
 *
 * Active page types: 'jacket-listing', 'jacket-details', 'dickey-listing',
 * 'summary'
 *
 */

export default {
  namespaced: true,

  state: () => ({
    selectedJacket: false,
    selectedJacketVariant: false,
    selectedJacketStoreIndex: false,
    selectedJackets: [],
    selectedDickeys: [],
    selectedSize: false,
    activePage: 'jacket-listing',
    availableIndex: 1,
    isEditingProduct: false,
  }),

  mutations: {

    /**
     * Set jacket.
     */
    SET_JACKET(state, jacket) {
      state.selectedJacket = jacket
    },

    /**
     * Set jacket variant.
     */
    SET_JACKET_VARIANT(state, variant) {
      state.selectedJacketVariant = variant
    },

    /**
     * Updated viewed jacket index
     */
    SET_JACKET_STORE_INDEX(state, variant) {
      state.selectedJacketStoreIndex = variant
    },

    /**
     * Remove jacket data
     */
    REMOVE_JACKET(state) {
      state.selectedJacket = false
      state.selectedJacketVariant = false
    },

    /**
     * Remove dickey from the list
     */
    REMOVE_DICKEY(state, dickey) {
      const dickeyIds = state.selectedDickeys.map((item) => item.id)

      if (dickeyIds.includes(dickey.id)) {
        const index = dickeyIds.indexOf(dickey.id)
        state.selectedDickeys.splice(index, 1)
      }
    },

    /**
     * Set dickey.
     */
    ADD_DICKEY(state, dickey) {
      const dickeyIds = state.selectedDickeys.map((item) => item.id)

      if (dickeyIds.includes(dickey.id)) {
        const index = dickeyIds.indexOf(dickey.id)
        state.selectedDickeys.splice(index, 1)

        return
      }

      state.selectedDickeys.push(dickey)
    },

    /**
     * Set page.
     */
    SET_PAGE(state, page) {
      state.activePage = page
    },

    /**
     * Add jacket
     */
    ADD_JACKET(state, jacket) {
      if (jacket.storeIndex) {
        state.selectedJackets.push(jacket)
        state.availableIndex = Math.max(jacket.storeIndex, state.availableIndex) + 1

        return
      }

      state.selectedJackets.push({
        storeIndex: state.availableIndex,
        product: jacket,
        variant: false,
      })

      state.selectedJacketStoreIndex = state.availableIndex
      state.availableIndex += 1
    },

    /**
     * Update Jacket in Jacket list
     */
    UPDATE_JACKET(state, { jacket, storeIndex }) {
      for (const item of state.selectedJackets) {
        if (item.storeIndex === storeIndex) {
          item.product = jacket
        }
      }
    },

    /**
     * Append variant to Jacket list
     */
    APPEND_VARIANT(state, { variant, storeIndex }) {
      for (const jacket of state.selectedJackets) {
        if (jacket.storeIndex === storeIndex) {
          jacket.variant = variant
        }
      }
    },

    /**
     * Remove jacket from array
     */
    REMOVE_JACKET_FROM_ARRAY(state, storeIndex) {
      const storeIndexes = state.selectedJackets.map((item) => item.storeIndex)

      if (storeIndexes.includes(storeIndex)) {
        const index = storeIndexes.indexOf(storeIndex)
        state.selectedJackets.splice(index, 1)
      }
    },

    /**
     * Set is product being edited
     * @param {*} state
     * @param {*} isEditing
     */
    IS_EDITING_PRODUCT(state, isEditing) {
      state.isEditingProduct = isEditing
    },
  },

  actions: {

    /**
      * Set jacket data.
      * @param {Object} jacket.
      */
    setJacket({ commit }, jacket = false) {
      commit('SET_JACKET', jacket)
    },

    /**
      * Set jacket variant data.
      * @param {Object} variant.
      */
    setJacketVariant({ commit }, variant = false) {
      commit('SET_JACKET_VARIANT', variant)
    },

    /**
     * Update selected jacket index
     */
    setCurrentJacketStoreIndex({ commit }, index = false) {
      commit('SET_JACKET_STORE_INDEX', index)
    },

    /**
      * Remove jacket.
      */
    removeCurrentJacket({ commit }) {
      commit('REMOVE_JACKET')
    },

    /**
     * Remove Dickey
     * @param {Object} dickey.
     */
    removeDickey({ commit }, dickey = false) {
      commit('REMOVE_DICKEY', dickey)
    },

    /**
      * Set dickey data.
      * @param {Object} dickey.
      */
    addDickey({ commit }, dickey = false) {
      commit('ADD_DICKEY', dickey)
    },

    /**
      * Set active page.
      * @param {String} page.
      */
    setPage({ commit }, page = false) {
      commit('SET_PAGE', page)
    },

    /**
     * Add Jacket into array
     */
    addJacket({ commit }, jacket = false) {
      commit('ADD_JACKET', jacket)
    },

    /**
     * Update jacket in the array
     */
    updateJacket({ commit }, { jacket, storeIndex }) {
      commit('UPDATE_JACKET', { jacket, storeIndex })
    },

    /**
     * Remove JAcket from array of jackets
     * @param {*} storeIndex
     */
    removeJacket({ commit }, storeIndex = false) {
      commit('REMOVE_JACKET_FROM_ARRAY', storeIndex)
    },

    /**
     * Add Jacket variant to the object
     */
    appendJacketVariant({ commit }, { variant, storeIndex }) {
      commit('APPEND_VARIANT', { variant, storeIndex })
    },

    /**
     * Add Jacket variant to the object
     */
    setIsEditingProduct({ commit }, isEditing) {
      commit('IS_EDITING_PRODUCT', isEditing)
    },
  },
}
